import recorder from '../recorder.js';
import Tone from 'tone';
import Notes from 'midi/Notes.js';
import {getMilliseconds} from './getMilliseconds.js';
import {
    setIsResampling,
    setTrackToFreeze} from 'actions/index.js';
import SoundUploader from 'api/SoundUploader.js';
import Sample from 'repos/Sample.js';
import {setResampleMaster} from 'actions/index.js';
const DELAY = 400;

class Resampler {
    constructor(sequencerEngine, input, isMaster=false) {
        this.sequencerEngine = sequencerEngine;
        this.input = input;
        this.soundUploader = new SoundUploader(
            2, (soundId, ipfsHash, loopNumber) => this.onSoundUploaded(ipfsHash));
        this.isMaster = isMaster;

        this.resampleCount = 0;
    }

    getRecorder() {
        return new window.Recorder(this.input, {numChannels: 2, bufferLen: 1024});
    }

    start(time, track, freeze=false) {
        this.track = track;
        this.freeze = freeze;
        this.sequencerEngine.store.dispatch(setIsResampling(
            track !== undefined ? track.trackNumber : true));
        this.resamplingDurationElapsed = 0;
        this.recorder.record(time);
    }

    stop(time) {
        let milli = getMilliseconds(time) + DELAY;
        if (!this.autoResampleMode) {
            time += 0.2
        }
        this.recorder.stop(time);
        setTimeout(() => { 
            this.recorder.getBuffer((blob) => this.saveBuffer(blob)); 
            this.sequencerEngine.store.dispatch(setIsResampling(undefined));
        }, milli + 500);
    }
    
    saveBuffer(blob) {
        let frameCount = blob[0].length;
        if (frameCount === 0) {
            console.log('frame count for blob is 0 so redoing the damn shit!');
            this.redoResample();
            return;
        }
        this.audioBuffer = this.getAudioBuffer(blob);
        this.soundUploader.uploadBufferToIpfs(blob, true, 0);
    }

    getAudioBuffer(blob) {
        let frameCount = blob[0].length;
        let audioBuffer = Tone.Master.context.createBuffer(2, frameCount, Tone.Master.context.sampleRate);  
        audioBuffer.copyToChannel(blob[0], 0, 0);
        audioBuffer.copyToChannel(blob[1], 1, 0);
        return audioBuffer;
    }

    get autoResampleTrack() {
        return this.sequencerEngine.tracks[0];
    }

    get autoResampleTrackNote() {
        return this.autoResampleTrack.pattern.stepBuckets[0].steps[0].transpose;
    }

    incrementNotes(inc) {
        let buckets = this.autoResampleTrack.pattern.stepBuckets;
        for (let bucket of buckets) {
            for (let key in bucket.steps) {
                bucket.steps[key].getPolyphony()
                    .forEach(s => s.transpose += inc);
            }
        }
    }

    get autoResampleMode() {
        return this.sequencerEngine.autoResampleMode;
    }

    get samplesPerNote() {
        return this.sequencerEngine.resampleConfig.samplesPerNote;
    }

    onSoundUploaded(ipfsHash) {
        let sample = new Sample(ipfsHash);
        sample.audioBuffer = this.audioBuffer;
        sample.name = 'Resampled Recording';
        sample.tags = ['Resampled'];

        if (this.autoResampleMode) {
            sample.name = Notes.fromTranspose(this.autoResampleTrackNote).toString();

            let track = this.autoResampleTrack;
            if (track.midiOutputs) {
                sample.tags.push(Array.from(track.midiOutputs)[0].name);
            }
        }
        sample.isResampled = true;
        sample.samplesUsed = [];

        if (this.isMaster) {
            // find all the unmuted samples used in resample
            let unmutedSamples = this.sequencerEngine.tracks
                .filter(x => !x.muted && x.sample)
                .map(x => x.sample);
            // get the tags
            sample.samplesUsed = unmutedSamples.map(x => x.getId());
        }

        if (sample.samplesUsed === undefined) {
            sample.samplesUsed = [];
        }

        if (this.freeze) {
            this.track.freeze(sample);
        } else {
            if (this.sampledInstrument === undefined) {
                this.sampledInstrument = this.sequencerEngine.addSampledInstrumentTrack();
                if (this.autoResampleMode) {
                    this.matchLengths(this.sampledInstrument);
                }
            }
            this.sampledInstrument.instrument.newSample(undefined, sample);
            this.sequencerEngine.recordingsToSave.push(sample);
            /*
            this.sequencerEngine.addSound(sample, undefined, undefined, undefined, true)
                .then(track => {
                    if (this.autoResampleMode) {
                        this.matchLengths(track);
                    }
                });
                */
        }

        if (this.autoResampleMode) {
            console.log("AUTO RESAMPLE MMODEE PREPARE");
            this.prepare();
            if (this.resampleCount % this.samplesPerNote === 0) {
                this.incrementNotes(2);
                // this.autoResampleTrackNote = this.autoResampleTrackNote + 2;
            }
            this.resampleCount++;
            this.sequencerEngine.store.dispatch(setResampleMaster(true));
        }
    }

    prepare() {
        if (this.recorder === undefined) {
            this.recorder = this.getRecorder();
        } else {
            this.recorder.clear();
        }
    }

    matchLengths(track) {
        while (track.length > this.autoResampleTrack.length) {
            track.halfTrackLength();
        }
    }

    dispatch(x) {
        this.sequencerEngine.store.dispatch(x);
    }

    redoResample() {
        if (!this.isMaster) {
            this.dispatch(setTrackToFreeze(
                this.track.subSequence.id,
                this.track.trackNumber));
        } else {
            this.dispatch(setResampleMaster(true));
        }
    }

}

export default Resampler;
